<template>
        <div class="myskov-order-block" v-if="order" :class="{'myskov-order-block--print': printOrder}">
            <div class="myskov-order-block__header">
                <hotel-block-header :hotel="hotelHeader" :order-number="order.bookingCode" :show-favorite="false"></hotel-block-header>
            </div>
            <div class="agency-block agency-block--verified agency-block--status-OK">
                <div class="agency-block__header" v-if="tourOperator">
                    <div class="agency-block__header__name">
                        <span v-text="translations.title"></span>
                        <h2 v-text="tourOperator.name"></h2>
                        <span v-text="translations.trip_to"></span>
                        <h2 v-if="hotel && hotel.location" v-text="hotel.location.name"></h2>
                    </div>
                    <div class="agency-block__header__logo">
                        <img :src="tourOperator.logo" :alt="tourOperator.name">
                    </div>
                </div>
                <div class="travel-block-grid" v-if="outboundFlight || inboundFlight">
                    <travel-block v-if="outboundFlight" :title="translations.travel_out"  :flight-data="outboundFlight"></travel-block>
                    <travel-block v-if="inboundFlight" :title="translations.travel_home" :flight-data="inboundFlight"></travel-block>
                </div>
                <p class="agency-block__travel-disclaimer" v-text="translations.notice">Med forbehold for flytidsændringer</p>
                <div class="order-travelers">
                    <div class="order-travelers__header">
                        <span>{{ translations.travellers }} {{ numberOfTravelers }}</span>
                    </div>
                    <div class="order-travelers__grid">
                        <traveller v-for="(traveller, travellerKey) in travelllers" :traveller="traveller" :key="travellerKey" :number="(travellerKey + 1)"></traveller>
                    </div>
                </div>
                <div class="agency-block__priced-included-wrapper">
                    <div class="included-item-grid"><!---->
                        <included-item v-if="packageOffer && packageOffer.transferIncluded" :title="translations.includes.transfer_included" icon-type="transfer"></included-item>
                        <included-item v-if="packageOffer && !packageOffer.transferIncluded"  :title="translations.includes.transfer_not_included" icon-type="transfer"></included-item>
                        <included-item :title="translations.includes.loggage_included" icon-type="baggage"></included-item>
                        <included-item v-if="originalRoomtypeName" :title="originalRoomtypeName" :translatedTitle="translatedRoomTypeName" icon-type="hotel" translatable="true"></included-item>
                        <included-item v-if="hotelOffer && hotelOffer.boardType" :title="hotelOffer.boardType.name" icon-type="food"></included-item>
                        <included-item :title="translations.includes.flight_class" icon-type="flightclass"></included-item>
                        <included-item v-if="bookingInformation && bookingInformation.accommodatesDisabledGuests" :title="translations.includes.handicap" icon-type="handicap"></included-item>
                        <included-item v-if="bookingInformation && !bookingInformation.accommodatesDisabledGuests" :title="translations.includes.not_handicap" icon-type="noHandicap"></included-item>
                    </div>
                    <total-price v-if="totalPrice" :totalPrice="totalPrice.value" :currency="totalPrice.currency"></total-price>
                </div>
                <div class="agency-block__actions">
                    <a href="javascript:void(0)" class="btn btn--travel-description" @click="onPrint"> 
                        <span class="btn__text" v-text="translations.print_btn"></span>
                    </a>
                    <a href="javascript:void(0)" class="btn btn--positive" @click="onContact">
                        <span class="btn__text" v-text="translations.contact_btn"></span>
                    </a>
                </div>
            </div>
        </div>
</template>

<script>
import HotelBlockHeader from './hotel-block/hotel-block-header.vue';
import IncludedItem from './included-item.vue';
import TotalPrice from './total-price.vue';
import TravelBlock from './travel-block.vue';
import Traveller from './traveller.vue';
import _ from 'underscore';


export default {
    props: {
        order: {type: [Object, Array], default: null}
    },
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.ORDER,
            printOrder: false
        }
    },
    methods: {
        onContact() {
            if(this.order) {
                window.location = '/support/kontakt-os?bookingnumber=' + this.order.bookingCode;
            }
        },
        onPrint() {
            if(this.order) {
                this.printOrder = true;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.printOrder = false;
                    }, 500);
                    window.print();
                });
            }
        }
    },
    computed: {
        numberOfTravelers() {
            let travellers = this.travelllers;

            if(!travellers) {
                return '';
            }

            let adults = travellers.filter((traveller) => traveller.type != 'K').length;
            let childrenCount = travellers.filter((traveller) => traveller.type == 'K').length;

            let str = adults.toString() + ' ';
            str += (adults > 1 || adults === 0) ? this.translations.adults : this.translations.adult_single;
            str += ', ' + childrenCount + ' ';
            str += (childrenCount > 1 || childrenCount === 0) ? this.translations.children : this.translations.children_single;
            return str;
        },
        packageOffer() {
            if(this.order && this.order.packageOffer) {
                return this.order.packageOffer;
            }

            return null;
        },
        hotelHeader() {
            if(this.hotel) {
                return {
                    id: this.hotel.id || null,
                    title: this.hotel.name || '',
                    location: _.propertyOf(this.hotel)(['location', 'name']) || '',
                    rating: this.hotel.rating || { }, 
                    stars: this.hotel.category || 0
                }
            }

            return { };
        },
        hotel() {
            if(this.hotelOffer) {
                return this.hotelOffer.hotel;
            }

            return null;
        },
        hotelOffer() {
            if(this.packageOffer) {
                return this.packageOffer.hotelOffer;
            }

            return null;
        },
        originalRoomtypeName() {
            if(this.hotelOffer && this.hotelOffer.roomType) {
                let roomName = [this.hotelOffer.roomType.name];
                if(this.hotelOffer.roomType.additionalRoomName) {
                    roomName.push(this.hotelOffer.roomType.additionalRoomName);
                }

                return roomName;
            }

            return [ ];
        },
        translatedRoomTypeName() {
            if(this.hotelOffer && this.hotelOffer.roomType && this.hotelOffer.roomType.translatedAdditionalRoomName) {
                return  [this.hotelOffer.roomType.name, this.hotelOffer.roomType.translatedAdditionalRoomName];
            }

            return [ ];
        },
        tourOperator() {
            if(this.packageOffer) {
                return this.packageOffer.tourOperator;
            }

            return null;
        },
        inboundFlight() {
            if(this.packageOffer && this.packageOffer.flightOffer) {
                return {
                    estimatedTime: (this.packageOffer.flightOffer) ? this.packageOffer.flightOffer.flight.inboundEstimatedTravelTime : null,
                    legList: (this.packageOffer.flightOffer) ? this.packageOffer.flightOffer.flight.inboundLegList : null,
                    travelDate: (this.dates) ? this.dates.toDate : null,
                    airports: (this.packageOffer.flightOffer) ? [this.packageOffer.flightOffer.flight.arrivalAirport, this.packageOffer.flightOffer.flight.departureAirport] : [null, null]
                }
            }

            return null;
        },
        outboundFlight() {
            if(this.packageOffer && this.packageOffer.flightOffer) {
                return {
                    estimatedTime: (this.packageOffer.flightOffer) ? this.packageOffer.flightOffer.flight.outboundEstimatedTravelTime : null,
                    legList: (this.packageOffer.flightOffer) ? this.packageOffer.flightOffer.flight.outboundLegList : null,
                    travelDate: (this.dates) ? this.dates.fromDate : null,
                    airports: (this.packageOffer.flightOffer) ? [this.packageOffer.flightOffer.flight.departureAirport, this.packageOffer.flightOffer.flight.arrivalAirport] : [null, null]
                }
            }

            return null;
        },
        dates() {
            if(this.packageOffer) {
                return this.packageOffer.travelDate;
            }

            return null;
        },
        totalPrice() {
            if(this.packageOffer) {
                return this.packageOffer.totalPrice;
            }

            return null;
        },
        travelllers() {
            if(this.order) {
                return this.order.travellers || [ ];
            }

            return [ ];
        },
        bookingInformation() {
            if(this.order) {
                return this.order.bookingInformation;
            }

            return
        }
    },
    components: {
        HotelBlockHeader,
        IncludedItem,
        TotalPrice,
        TravelBlock,
        Traveller
    }
}
</script>
